// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RZ77","footer":"styles_footer__sjpb_","passCodeTooltip":"styles_passCodeTooltip__IZJGC"};